import { Stack, Typography } from '@mui/material';

interface IPermissionModalContentProps {
	description: string;
	subDescription?: string;
}

export const PermissionModalContent = ({
	description,
	subDescription,
}: IPermissionModalContentProps) => {
	return (
		<Stack width="100%" gap={3}>
			<Typography
				variant="body1"
				sx={{
					'&:empty': {
						display: 'none',
					},
				}}
			>
				{description}
			</Typography>
			{subDescription && (
				<Typography variant="body1">{subDescription}</Typography>
			)}
		</Stack>
	);
};
